import * as React from "react";
import type { SVGProps } from "react";
const SvgManualIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="manual_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M768 64H256A170.667 170.667 0 0 0 85.333 234.667v554.666A170.667 170.667 0 0 0 256 960h512a170.667 170.667 0 0 0 170.667-170.667V234.667A170.667 170.667 0 0 0 768 64zM170.667 234.667A85.333 85.333 0 0 1 256 149.333v256a42.667 42.667 0 0 0 68.267 34.134l59.733-44.8 59.733 44.8A42.667 42.667 0 0 0 512 405.333v-256h256a85.333 85.333 0 0 1 85.333 85.334v554.666A85.333 85.333 0 0 1 768 874.667H256a85.333 85.333 0 0 1-85.333-85.334V234.667zm256-85.334V320L409.6 307.2a42.667 42.667 0 0 0-51.2 0L341.333 320V149.333h85.334z"
    />
  </svg>
);
export default SvgManualIcon;
